import { staticSettings } from '../state/ui-store';

export const isTypeOf_MaintainanceInstruction = () => {
  return staticSettings.sidebar.renderGovieBttn;
};
